export const SET_REFRESH_USER_TABLE = 'SET_REFRESH_USER_TABLE';
export const setRefreshUsersTable = (refresh:number) => ({
  type: SET_REFRESH_USER_TABLE,
  payload: refresh,
});

const initialState = 0;

interface Action {
  type: string;
  payload: number;
}

const setRefreshUsersTableReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_REFRESH_USER_TABLE:
      return action.payload;

    default:
      return state;
  }
};
export default setRefreshUsersTableReducer;
